import { AnimatePresence, motion } from 'framer-motion'
import { useAuthStore } from '@/stores/auth.store'
import { OAuthButtons } from './OAuthButtons'

export function LoginModal() {
  const { isLoginModalOpen, closeLoginModal } = useAuthStore()

  return (
    <AnimatePresence>
      {isLoginModalOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={closeLoginModal}
        >
          <motion.div
            className="bg-arcade-surface border border-arcade-border rounded-2xl p-8 w-full max-w-sm mx-4"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-2xl font-bold text-white mb-1">Sign in</h2>
            <p className="text-gray-400 text-sm mb-6">
              Your progress is saved to your account.
            </p>
            <OAuthButtons />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
